var map = {
	"./behance.svg": "dd44",
	"./dribble.svg": "b0d6",
	"./location.svg": "bbb9",
	"./mail.svg": "2b24",
	"./phone.svg": "6ac0",
	"./telegram.svg": "fef4",
	"./whatsapp.svg": "2dfb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7f949";